import { lazy } from 'react';
import Route from '@interfaces/Route';

export const Routes: Route[] = [];
export default Routes;
